import { Store } from '@jwplayer/fe-common/module/store/react';

import type { BotrStatusResponse } from '/module/api-read-only-status/types';
import type { SystemStatus } from '/module/system-status/types';

export const StatusStore = new Store<{
  botrStatus: BotrStatusResponse | null;
  systemStatus: SystemStatus | null;
}>({
  botrStatus: null,
  systemStatus: null,
});
